export default __webpack_public_path__ + "static/media/banner02.d97fbcf1.png";